import { postAction } from '@/eiuov-utils/axios/api'

const queryWorksListInHomeAction = (params) => postAction('/reception/home/queryWorksList', params)
const queryArticleListInHomeAction = (params) => postAction('/reception/home/queryArticleList', params)
const queryPoemListInHomeAction = (params) => postAction('/reception/home/queryPoemList', params)
const queryHomeBlockInHomeAction = (params) => postAction('/reception/home/queryHomeBlock', params)
const queryCarouselListInHomeAction = (params) => postAction('/reception/home/queryCarouselList', params)
const queryCarouselBgListInHomeAction = (params) => postAction('/reception/home/queryCarouselBgList', params)
const queryCarousel1smallListInHomeAction = (params) => postAction('/reception/home/queryCarousel1smallList', params)
const queryCarousel1smallBy9999 = (params) => postAction('/reception/home/queryCarousel1smallBy9999', params)

export {
    queryWorksListInHomeAction,
    queryArticleListInHomeAction,
    queryPoemListInHomeAction,
    queryHomeBlockInHomeAction,
    queryCarouselListInHomeAction,
    queryCarouselBgListInHomeAction,
    queryCarousel1smallListInHomeAction,
    queryCarousel1smallBy9999,
}
